module.exports = __webpack_public_path__ + "img/t1-events.2b061126.png";